<template>
    <div>

<div class="row container" role="main">
    <div class="col">

        <div class="login">
            <h2>{{ app_title() }}</h2>
            <div v-if="einlogvorgang_laeuft_gerade" class="container-loading">
            <img src="/img/spinner/curved-bar-spinner.gif" alt="Loading Icon">
            </div>
            <p v-if="login_error">{{ login_error }}</p>
            <form @submit.prevent="loginSubmit">
            <input type="email" placeholder="E-Mail" v-model="email" autocomplete="current-username">
            <input type="password" placeholder="Password" v-model="password"  autocomplete="current-password">
            <button type="submit">Login</button>
            </form>
        </div>
        
    </div>
</div>
<Footer></Footer>


  </div>
</template>

<script>
// https://webdevchallenges.com/vue-js-login-component-with-spinner/

import axios from 'axios';
import Footer from './Footer.vue';

// Mixin fuer diese Komponente importieren
import loginzustand from './mixins/loginzustand.js';
import commonvars from './mixins/commonvars.js';


export default {
    data() {
        return {
            email: '',
            password: '',
            login_error: "",
            einlogvorgang_laeuft_gerade: false
        }
    },
    components: {
        Footer
    },
    mixins: [
      loginzustand,
      commonvars
    ],
    mounted: function() {
      console.log("Hier ist Login");
      this.pruefe_ob_schon_eingeloggt();
    },
    methods: {
        loginSubmit() {
            this.einlogvorgang_laeuft_gerade = true;
            let api_login_url = window.global_mycover.server_base_url + "/api/login";
            console.log("Ich starte Login via API mit: " + api_login_url);
            // Axios sendet post per Default mit: application/json
            axios.post(api_login_url, { email: this.email, password: this.password })
                .then(
                  (response) => {
                    console.log(response.data)
                    this.einlogvorgang_laeuft_gerade = false;
                    console.log("Login war erfolgreich, ich setze access_token in localStorage");
                    localStorage.setItem('access_token', response.data.access_token);
                    this.setze_access_token_aus_localstorage_in_axios_header();
                    console.log("Weiterleitung per push nach " + this.startseite_nach_login() );
                    this.$router.push( this.startseite_nach_login() );
                })
                .catch(
                  () => {
                    console.log("Login war nicht erfolgreich, ich loesche access_token in localStorage");
                    localStorage.clear();
                    this.einlogvorgang_laeuft_gerade = false;
                });
        },
        pruefe_ob_schon_eingeloggt() {
          console.log("Ich pruefe sofort ob der Leser vielleicht schon eingeloggt ist, wenn ja braucht er sich ja nicht mehr einloggen und kann gleich weitergeleitet werden");
          let api_loginstatus_url = this.server_base_url() + "/api/login/status";
          console.log(api_loginstatus_url);
          axios.post(api_loginstatus_url)
            .then(
              (response) => {
                console.log(response.data)
                this.einlogvorgang_laeuft_gerade = false;
                console.log("Login.vue: User ist schon eingeloggt");
                console.log("Pushe User nach " + this.startseite_nach_login() );
                this.$router.push( this.startseite_nach_login() );
              }
            )
            .catch(
              (error) => {
                console.log("Login.vue: User ist noch nicht eingeloggt, Status ");
                console.log("Fehler war: " + error.message);
            }
          );
        },
        startseite_nach_login() {
          return "/uploadcover";
        }
    },
}
</script>


<style scoped lang="scss">
  .login {
    margin-top: 100px;
    border: 1px solid black;
    border-radius: 5px;
    padding: 1.5rem;
    width: 350px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    .container-loading {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(0,0,0,.3);
      img {
        width: 2rem;
        height: 2rem;
      }
    }

    h2 {
        text-align: center;
        padding-bottom: 10px;
    }

    form {
      display: flex;
      flex-flow: column;
      *:not(:last-child) {
        margin-bottom: 1rem;
      }
      input {
        padding: .5rem;
      }
      button {
        padding: .5rem;
        background-color: lightgray;
        border: 1px solid gray;
        border-radius: 3px;
        cursor: pointer;
        &:hover {
          background-color: lightslategray;
        }
      }
    }
  }
</style>